/**
 * @generated SignedSource<<f893f9a7720211b3f5999fcebed1b4c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type JobEstimateSourceEnum = "SYSTEM" | "USER";
export type JobScheduleStatusEnum = "AHEAD" | "DELAYED" | "ON_TIME";
export type JobStatusEnum = "CANCELLED" | "COMPLETED" | "RUNNING" | "SCHEDULED";
export type TemplateCategoryEnum = "SURGERY" | "TURNOVER";
export type ORColumnSubscription$variables = {
  id: string;
};
export type ORColumnSubscription$data = {
  readonly operatingRoomScheduleUpdate: {
    readonly node: {
      readonly actualStartTime: any | null | undefined;
      readonly actualStopTime: any | null | undefined;
      readonly durations: {
        readonly delayAfterMinutes: number | null | undefined;
        readonly dynamicDurationMinutes: number | null | undefined;
        readonly plannedDurationMinutes: number | null | undefined;
      } | null | undefined;
      readonly estimateSource: JobEstimateSourceEnum | null | undefined;
      readonly estimatedStartTime: any | null | undefined;
      readonly estimatedStopTime: any | null | undefined;
      readonly events: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly happenedAt: any | null | undefined;
            readonly id: string;
            readonly type: {
              readonly id: string;
              readonly name: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly location: {
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly name: string | null | undefined;
      readonly patientMrn: string | null | undefined;
      readonly patientName: string | null | undefined;
      readonly plannedStart: any | null | undefined;
      readonly plannedStop: any | null | undefined;
      readonly scheduleStatus: JobScheduleStatusEnum | null | undefined;
      readonly serviceName: string | null | undefined;
      readonly status: JobStatusEnum | null | undefined;
      readonly surgeonName: string | null | undefined;
      readonly template: {
        readonly category: TemplateCategoryEnum | null | undefined;
      } | null | undefined;
      readonly turnover: {
        readonly actualStartTime: any | null | undefined;
        readonly actualStopTime: any | null | undefined;
        readonly durations: {
          readonly delayAfterMinutes: number | null | undefined;
          readonly dynamicDurationMinutes: number | null | undefined;
          readonly plannedDurationMinutes: number | null | undefined;
        } | null | undefined;
        readonly estimateSource: JobEstimateSourceEnum | null | undefined;
        readonly estimatedStartTime: any | null | undefined;
        readonly estimatedStopTime: any | null | undefined;
        readonly events: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly happenedAt: any | null | undefined;
              readonly id: string;
              readonly type: {
                readonly id: string;
                readonly name: string | null | undefined;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
        readonly plannedStart: any | null | undefined;
        readonly plannedStop: any | null | undefined;
        readonly scheduleStatus: JobScheduleStatusEnum | null | undefined;
        readonly status: JobStatusEnum | null | undefined;
        readonly template: {
          readonly category: TemplateCategoryEnum | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ORColumnSubscription = {
  response: ORColumnSubscription$data;
  variables: ORColumnSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "operatingRoomId",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedStart",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedStop",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedStartTime",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedStopTime",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualStartTime",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualStopTime",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientMrn",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surgeonName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduleStatus",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Durations",
  "kind": "LinkedField",
  "name": "durations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dynamicDurationMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "delayAfterMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedDurationMinutes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateSource",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Template",
  "kind": "LinkedField",
  "name": "template",
  "plural": false,
  "selections": [
    (v18/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 20
    }
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "happenedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EventType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "events(first:20)"
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Template",
  "kind": "LinkedField",
  "name": "template",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ORColumnSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SurgeryEdge",
        "kind": "LinkedField",
        "name": "operatingRoomScheduleUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Surgery",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Location",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Turnover",
                "kind": "LinkedField",
                "name": "turnover",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ORColumnSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SurgeryEdge",
        "kind": "LinkedField",
        "name": "operatingRoomScheduleUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Surgery",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Location",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              (v17/*: any*/),
              (v21/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Turnover",
                "kind": "LinkedField",
                "name": "turnover",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v21/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75936030d236e863fe8b3d8e0ce272d6",
    "id": null,
    "metadata": {},
    "name": "ORColumnSubscription",
    "operationKind": "subscription",
    "text": "subscription ORColumnSubscription(\n  $id: ID!\n) {\n  operatingRoomScheduleUpdate(operatingRoomId: $id) {\n    node {\n      id\n      name\n      plannedStart\n      plannedStop\n      estimatedStartTime\n      estimatedStopTime\n      actualStartTime\n      actualStopTime\n      patientMrn\n      patientName\n      surgeonName\n      serviceName\n      status\n      scheduleStatus\n      location {\n        name\n        id\n      }\n      durations {\n        dynamicDurationMinutes\n        delayAfterMinutes\n        plannedDurationMinutes\n      }\n      estimateSource\n      template {\n        category\n        id\n      }\n      events(first: 20) {\n        edges {\n          node {\n            id\n            happenedAt\n            type {\n              id\n              name\n            }\n          }\n        }\n      }\n      turnover {\n        id\n        name\n        plannedStart\n        plannedStop\n        estimatedStartTime\n        estimatedStopTime\n        actualStartTime\n        actualStopTime\n        status\n        scheduleStatus\n        durations {\n          dynamicDurationMinutes\n          delayAfterMinutes\n          plannedDurationMinutes\n        }\n        estimateSource\n        template {\n          category\n          id\n        }\n        events(first: 20) {\n          edges {\n            node {\n              id\n              happenedAt\n              type {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2eba8149e2eeb4dec345deeb81287e48";

export default node;
